import { Button, Modal } from "minimum-ui/core";
import { Props as ModalProps } from "minimum-ui/core/Modal/Modal";

const StatusModal: React.FC<ModalProps> = ({ content, actions, ...rest }) => {
  const handleDismiss = () => {
    if (rest.onDismiss) {
      (rest.onDismiss as () => void)?.();
    }
  };

  return (
    <Modal
      {...rest}
      content={content ? <>{content}</> : null}
      actions={
        actions ? <>{actions}</> : <Button onClick={handleDismiss}>Ok</Button>
      }
    />
  );
};

export default StatusModal;
